import React          from 'react'
import DropdownList   from './DropdownList'
import DropdownSelect   from './DropdownSelect'

export const Dropdown = (props) => {
  return (
    <div style={{ 'display':'inline-block' }}>
      <DropdownList {...props}/>
      <DropdownSelect {...props}/>
    </div>
  )
}

export default Dropdown



// WEBPACK FOOTER //
// ../app/components/common/Dropdown.jsx